__turbopack_context__.v({
  "className": "WiGaBa_className",
  "variable": "WiGaBa_variable",
});
